import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DummyDataService } from '../../Services/dummy-data.service';
import { DemoEnvironmentService } from '../../Services/demo-environment.service';
import { ProjectService } from '../../Services/project.service';
import { SharedService } from '../../Services/sharedService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sample-data-banner',
  templateUrl: './sample-data-banner.component.html',
  styleUrls: ['./sample-data-banner.component.css'],
  standalone: false,
})
export class SampleDataBannerComponent implements OnInit, OnDestroy {
  isShowingDemoData = false;
  isRemoving = false;
  private subscription: Subscription;

  constructor(
    private dummyDataService: DummyDataService,
    private projectService: ProjectService,
    private router: Router,
    private sharedService: SharedService,
    private demoEnvironment: DemoEnvironmentService
  ) {}

  ngOnInit(): void {
    this.subscription = this.dummyDataService.isShowingDemoData$.subscribe((isShowing) => {
      this.isShowingDemoData = isShowing && !this.demoEnvironment.isDemoRealm();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  navigateToUsers(): void {
    this.router.navigate(['/employees'], { queryParams: { openCreateUser: 'true' } });
  }

  /** Exit sample mode entirely — sample data must never remain active without a visible indicator. */
  removeSampleData(): void {
    this.isRemoving = true;
    this.dummyDataService.clearLegacySampleMode();
    this.projectService.getUserList(0, 0, true).subscribe(
      () => {
        this.isRemoving = false;
        this.router.navigate(['/dashboard']);
      },
      () => {
        this.isRemoving = false;
        this.router.navigate(['/dashboard']);
      }
    );
  }

  /** Closing the banner exits sample mode (same as Hide). */
  closeBanner(): void {
    this.removeSampleData();
  }
}
